<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
    <template #modal-header>
      <p class="text-header">Connect Line Channel</p>
    </template>
    <b-form>
      <div>
        <InputText
          v-model="form.pageName"
          textFloat="Channel Name"
          placeholder="Type Channel Name"
          name="channelName"
          isRequired
          :isValidate="$v.form.pageName.$error"
          :v="$v.form.pageName"
          type="text"
        />
        <InputText
          v-model="form.pageId"
          textFloat="Channel ID"
          placeholder="Type Channel ID"
          name="channeLiineLoginId"
          isRequired
          :isValidate="$v.form.pageId.$error"
          :v="$v.form.pageId"
          type="text"
          textTooltip="ดูได้จาก Line Developers Consloe"
        />
        <InputText
          v-model="form.pageToken"
          textFloat="Channel Token"
          placeholder="Channel Token"
          name="pageToken"
          type="text"
          class="mt-2"
          isRequired
          :isValidate="$v.form.pageToken.$error"
          :v="$v.form.pageToken"
        />
      </div>
      <div v-if="form.channelConfigId > 0">
        <InputText
          v-model="form.lineLiffDomain"
          textFloat="Webhook API"
          placeholder="Webhook API"
          name="lineLiffDomain"
          type="text"
          disabled
          isCopy
          textTooltip="ถ้าคุณยังไม่เปิดใช้งาน Webhook เปิดใช้งานได้<a target='_blank' href='https://developers.line.biz/console/' class='text-danger'><b>ที่นี่</b></a>"
        />
        <button
          type="button"
          class="btn-main-1"
          @click="setWebhook()"
          :disabled="isLoading"
        >
          Set Webhook
        </button>
        <div class="mt-3">
          <toggle-button
            class="mt-1 mr-1 mb-0"
            v-model="form.isActive"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
            disabled
          />
          <span class="ml-2 f-size-18 text-header">
            {{ form.isActive ? "Active" : "Inactive" }}
          </span>
        </div>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button
          :disabled="isLoading"
          class="cancel-button"
          @click="onCloseModal()"
        >
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalConnectLineChannel",
  components: {
    InputText,
  },
  validations() {
    return {
      form: {
        pageName: { required },
        pageId: { required },
        pageToken: {required }
      },
    };
  },
  data: function () {
    return {
      showModal: false,
      isLoading: false,
      form: {
        brandId: 0,
        pageName: "",
        channelConfigId: "",
        pageId: "",
        lineLiffDomain: "",
        pageToken: "",
        isActive: true,
      },
      endpointWebhook: `${this.$webhookApiBaseUrl}/line/webhook`,
    };
  },
  watch: {
    "form.pageId"(newValue) {
      this.form.lineLiffDomain = `${this.endpointWebhook}/${newValue}`.trim();
    },
  },
  methods: {
    onShowModal: async function (item = false) {
      this.$v.$reset();
      if (item) this.form = { ...item };
      else this.setDefaultData();

      this.form.brandId = this.$route.query.brandID;
      this.form.lineLiffDomain = `${this.endpointWebhook}/${this.form.pageId}`.trim();
      this.showModal = true;
    },
    setDefaultData() {
      this.form = {
        brandId: 0,
        pageName: "",
        channelConfigId: 0,
        pageId: "",
        lineLiffDomain: "",
        pageToken: "",
        isActive: true,
      };
    },
    onCloseModal() {
      this.showModal = false;
    },
    async setWebhook() {
      this.isLoading = true;

      let result = await this.updateLineWebhook();

      if (result == 1) this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true });
      else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true });

      this.isLoading = false;
    },
    updateLineWebhook: async function () {
      let body = {
        brandId: this.form.brandId,
        endpoint: this.form.lineLiffDomain,
      };
      let result = 0;
      await this.axios
        .post(`${this.$baseUrl}/system/UpdateLineWebhook`, body)
        .then((data) => {
          if (data.result == 1) result = 1;
          else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });

      return result;
    },
    onSubmit: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      let result = await this.updateLineWebhook();
      if (result === 1) {
        let method = "put";
        if (this.form.channelConfigId == 0) method = "post";
        await this.axios({
          url: `${this.$baseUrl}/system/lineconfig`,
          method: method,
          data: this.form,
        })
          .then((data) => {
            if (data.result == 1) this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
            else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message });
          })
          .catch((err) => {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
          });
        this.isLoading = false;

        this.onCloseModal();
      }
    },
  },
};
</script>
